import {
    type EtaActionsType,
    FINISH_ETA_LOAD,
    FINISH_ETA_RATE_FETCH,
    INVALIDATE_ETA,
    RESET_ETA,
    START_ETA_LOAD,
} from "../actions/EtaActions";
import type { EtaStateType } from "../../../../../common-deprecated/types/CommonTypes";

export const initialState: EtaStateType = {
    loading: false,
    loaded: false,
    error: false,
    date: false,
    alternatives: [],
};

const etaReducer = (state: EtaStateType = initialState, action: EtaActionsType): EtaStateType => {
    switch (action.type) {
        case START_ETA_LOAD:
            return { ...state, loading: true, loaded: true, error: false };

        case FINISH_ETA_LOAD:
            return { ...state, ...action.eta, loading: false, loaded: true };

        case RESET_ETA:
            return { ...initialState, error: action.isError };

        case INVALIDATE_ETA:
            return { ...state, loaded: false, loading: false };

        case FINISH_ETA_RATE_FETCH:
            return { ...state, alternatives: action.result };

        default:
            return state;
    }
};

export default etaReducer;
